module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/wob-module-2-event-report.json
// module id = 1539
// module chunks = 280815330094384